import { render } from "./index.vue?vue&type=template&id=623b52ba"
import script from "./index.vue?vue&type=script&lang=ts"
export * from "./index.vue?vue&type=script&lang=ts"

import "./index.vue?vue&type=style&index=0&id=623b52ba&lang=css"
script.render = render

export default script